import { useFormatting } from './useFormatting';
import { useContractParams } from './useContractParams';
import { useCmgCalculations } from './useCmgCalculations';

/**
 * Main composable that orchestrates the CMG simulator.
 *
 * Composes three sub-composables:
 * - useFormatting()       → pure display utilities (toMoney, toFloatForDisplay, etc.)
 * - useContractParams()   → all reactive state, validation, week/month conversions
 * - useCmgCalculations()  → all financial computeds (CMG, taxes, costs)
 *
 * This maps to the old Vue 2 architecture:
 * - cmgSimulator mixin     → useContractParams
 * - cmg_calculations mixin → useCmgCalculations
 * - cmg_simulator_assmat   → this orchestrator
 */
export function useCmgSimulatorAssmat() {
  const formatting = useFormatting();
  const params = useContractParams(formatting);
  const calculations = useCmgCalculations(params);

  return {
    ...formatting,
    ...params,
    ...calculations,
  };
}
